module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-app', {
    attrs: {
      "light": ""
    }
  }, [_c('v-navigation-drawer', {
    staticClass: "pb-0",
    attrs: {
      "fixed": "",
      "app": "",
      "right": "",
      "temporary": "",
      "floating": "",
      "light": ""
    },
    model: {
      value: (_vm.sideNav),
      callback: function($$v) {
        _vm.sideNav = $$v
      },
      expression: "sideNav"
    }
  }, [_c('v-container', {
    attrs: {
      "grid-list-xl": "",
      "text-xs-center": "",
      "fill-height": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "align-content-space-between": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-list', [_vm._l((_vm.menuItems), function(item) {
    return _c('v-list-tile', {
      key: item.title,
      attrs: {
        "router": "",
        "to": item.link
      }
    }, [_c('v-list-tile-action', [_c('v-icon', {
      attrs: {
        "right": ""
      }
    }, [_vm._v(_vm._s(item.icon))])], 1), _vm._v(" "), _c('v-list-tile-content', [_vm._v("\n                    " + _vm._s(item.title) + "\n                  ")])], 1)
  }), _vm._v(" "), (_vm.userIsAuthenticate) ? _c('v-list-tile', {
    staticClass: "trialButton primary",
    attrs: {
      "router": "",
      "to": '/trial/new',
      "color": "primary",
      "dark": ""
    }
  }, [_c('v-list-tile-action', {
    staticClass: "white--text"
  }, [_c('v-icon', {
    staticClass: "white--text",
    attrs: {
      "left": ""
    }
  }, [_vm._v("add")])], 1), _vm._v(" "), _c('v-list-tile-content', {
    staticClass: "white--text"
  }, [_vm._v("\n                      New Trial\n                  ")])], 1) : _vm._e(), _vm._v(" "), (_vm.userIsAuthenticate) ? _c('v-list-tile', {
    attrs: {
      "router": "",
      "to": '/alert/new',
      "flat": ""
    }
  }, [_c('v-list-tile-action', [_c('v-icon', {
    attrs: {
      "left": ""
    }
  }, [_vm._v("add")])], 1), _vm._v(" "), _c('v-list-tile-content', [_vm._v("\n                    Update Alert\n                  ")])], 1) : _vm._e(), _vm._v(" "), (!_vm.userIsAuthenticate) ? [_c('app-edit-menu-login-dialog')] : _vm._e()], 2)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-list', [(_vm.userIsAuthenticate) ? _c('v-list-tile', {
    attrs: {
      "flat": ""
    },
    on: {
      "click": _vm.onLogout
    }
  }, [_c('v-list-tile-action', [_c('v-icon', {
    attrs: {
      "left": ""
    }
  }, [_vm._v("exit_to_app")])], 1), _vm._v(" "), _c('v-list-tile-content', [_vm._v("\n                    Log Out\n                  ")])], 1) : _vm._e()], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-toolbar', {
    staticClass: "primary",
    attrs: {
      "fixed": "",
      "dark": ""
    }
  }, [_c('div', {
    staticStyle: {
      "width": "52px"
    },
    attrs: {
      "right": ""
    }
  }, [(!_vm.checkLocations) ? _c('a', {
    on: {
      "click": function($event) {
        _vm.$router.go(-1)
      }
    }
  }, [_c('v-icon', [_vm._v("keyboard_arrow_left")])], 1) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "justify-center",
    staticStyle: {
      "width": "100%",
      "text-align": "center"
    },
    attrs: {
      "center": ""
    }
  }, [_c('router-link', {
    staticStyle: {
      "cursor": "pointer"
    },
    attrs: {
      "to": _vm.menuItems[0].link,
      "tag": "span"
    }
  }, [_c('v-icon', [_vm._v("home")])], 1)], 1), _vm._v(" "), _c('div', {
    attrs: {
      "right": ""
    }
  }, [_c('v-toolbar-side-icon', {
    staticClass: "hidden-xl-and-up mr-0",
    on: {
      "click": function($event) {
        _vm.sideNav = !_vm.sideNav
      }
    }
  })], 1), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-toolbar-items', {
    attrs: {
      "right": ""
    }
  })], 1), _vm._v(" "), _c('main', {
    staticClass: "white"
  }, [_c('router-view', {
    staticClass: "white"
  })], 1), _vm._v(" "), _c('footer', [_c('v-container', {
    staticClass: "mt-0"
  }, [_c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    staticClass: "text-xs-center mb-4"
  }, [_c('span', {
    staticClass: "white--text"
  }, [_vm._v("Copyright 2021 VIP Trials, LLC.")])])], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-628a8198","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 689
// module chunks = 1